import { Component, OnInit } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Component({
    selector: 'app-clients-page',
    templateUrl: './clients-page.component.html',
    styleUrls: ['./clients-page.component.scss']
})
export class ClientsPageComponent implements OnInit {

    constructor(private meta: Meta, private titleService: Title) { }

    ngOnInit(): void {
        this.titleService.setTitle('Our Clients | Union Fire Protection Qatar');
        this.meta.updateTag({
            name: 'description',
            content: 'Trusted by leading organizations across Qatar. Union Fire Protection has served residential, commercial, and industrial clients since 2007.'
        });
    }

    pageTitle = [
        {
            bgImage: 'assets/img/clients-banner.jpg',
            title: 'Our Valued Clients'
        }
    ]

    clientsContent = [
        {
            subTitle: "OUR CLIENTS",
            title: "Trusted by Leading Organizations",
            paragraph: "Since 2007, Union Fire Protection has been the preferred fire safety partner for leading organizations across Qatar. Our commitment to excellence and safety has earned us the trust of clients in residential, commercial, industrial, and government sectors."
        }
    ]

    clientCategories = [
        {
            id: 'all',
            name: 'All Clients',
            active: true
        },
        {
            id: 'government',
            name: 'Government',
            active: false
        },
        {
            id: 'commercial',
            name: 'Commercial',
            active: false
        },
        {
            id: 'residential',
            name: 'Residential',
            active: false
        },
        {
            id: 'industrial',
            name: 'Industrial',
            active: false
        }
    ]

    clients = [
        {
            logo: 'assets/img/clients/client1.png',
            name: 'Qatar Petroleum',
            category: 'government',
            sector: 'Oil & Gas'
        },
        {
            logo: 'assets/img/clients/client2.png',
            name: 'Barwa Real Estate',
            category: 'commercial',
            sector: 'Real Estate'
        },
        {
            logo: 'assets/img/clients/client3.png',
            name: 'Lusail Development',
            category: 'residential',
            sector: 'Residential'
        },
        {
            logo: 'assets/img/clients/client4.png',
            name: 'Qatar Foundation',
            category: 'government',
            sector: 'Education'
        },
        {
            logo: 'assets/img/clients/client5.png',
            name: 'Ezdan Holding',
            category: 'commercial',
            sector: 'Real Estate'
        },
        {
            logo: 'assets/img/clients/client6.png',
            name: 'Qatar Industrial Manufacturing',
            category: 'industrial',
            sector: 'Manufacturing'
        },
        {
            logo: 'assets/img/clients/client7.png',
            name: 'The Pearl Qatar',
            category: 'residential',
            sector: 'Residential'
        },
        {
            logo: 'assets/img/clients/client8.png',
            name: 'Doha Festival City',
            category: 'commercial',
            sector: 'Retail'
        }
    ]

    filteredClients = this.clients;

    filterClients(category: string): void {
        this.clientCategories.forEach(cat => cat.active = cat.id === category);
        
        if (category === 'all') {
            this.filteredClients = this.clients;
        } else {
            this.filteredClients = this.clients.filter(client => client.category === category);
        }
    }

}
